<template>
  <div v-if="video" class="tw:max-w-[300px] tw:mb-4 tw:border tw:border-gray-200 tw:rounded-lg tw:p-3 tw:shadow-sm">
    <div class="tw:cursor-pointer tw:transition-transform tw:hover:scale-[1.02]" @click="isOpen = true">
      <img
        :src="video.preview_path"
        :alt="video.title"
        class="tw:w-full tw:rounded-md tw:mb-2"
      >
    </div>
    <a class="tw:overflow-hidden tw:text-ellipsis tw:whitespace-nowrap tw:cursor-pointer tw:block" @click="isOpen = true">
      {{ video.title }}
    </a>
    <Dialog v-model:open="isOpen">
      <DialogContent class="tw:max-w-2xl">
        <DialogHeader>
          <DialogTitle>{{ video.title }}</DialogTitle>
        </DialogHeader>
        <div v-if="isOpen">
          <VideoIframe :url="embedUrl" :size="videoSize" />
        </div>
        <DialogFooter>
          <a
            :href="videoUrl"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-primary"
          >
            Open in new tab
          </a>
          <DialogClose as-child>
            <button type="button" class="btn btn-default">
              Close
            </button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </div>
</template>

<script setup>
import axios from 'axios'
import { computed, onMounted, ref } from 'vue'
import VideoIframe from '@/components/common/video-iframe.vue'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shadcn/components/ui/dialog/index.js'

const props = defineProps({
  canonical: {
    type: String,
    required: true,
  },
})

const video = ref(null)
const isOpen = ref(false)
const videoSize = ref('16-9')

const embedUrl = computed(() => Spark.router('web.video.embed', { canonical: props.canonical }))
const videoUrl = computed(() => Spark.router('web.video.show', { canonical: props.canonical }))

onMounted(() => {
  axios.get(Spark.router('api.video.show-by-canonical', { canonical: props.canonical }))
    .then((response) => {
      video.value = response.data.video

      const resolution = video.value.video_resolution
      if (resolution) {
        const ratio = resolution.height / resolution.width
        if (ratio <= 9 / 16) {
          videoSize.value = '16-9'
        }
        else if (ratio <= 2 / 3) {
          videoSize.value = '3-2'
        }
        else if (ratio <= 3 / 4) {
          videoSize.value = '4-3'
        }
        else {
          videoSize.value = '1-1'
        }
      }
    })
})
</script>
